module.exports = __webpack_public_path__ + "static/media/full-length-artist-photo.9c4d6878.jpg";